import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { t } from 'src/i18n';
import './d-app.js';
import { initMonitoring } from './utilities/monitoring.js';
import { setupNetworkErrorHandlers } from './utilities/network-error-handler.js';

const createUsernameInput = () => {
  const input = document.createElement('input');
  input.slot = 'usernameInput';
  input.placeholder = t('login.emailPlaceholder');
  input.type = 'email';
  input.name = 'loginName';
  input.autocomplete = 'username';
  return input;
};

const createPasswordInput = () => {
  const input = document.createElement('input');
  input.slot = 'passwordInput';
  input.placeholder = t('login.passwordPlaceholder');
  input.type = 'password';
  input.name = 'password';
  input.autocomplete = 'current-password';
  return input;
};

@customElement('app-root')
export class AppRoot extends LitElement {
  @property({ type: Number, attribute: 'body-scroll-top' })
  bodyScrollTop = 0;
  @property({ type: Number, attribute: 'body-scroll-left' })
  bodyScrollLeft = 0;
  @state()
  private readonly _usernameInput = createUsernameInput();
  @state()
  private readonly _passwordInput = createPasswordInput();

  constructor() {
    super();

    // Initialise CloudWatch RUM. Error noise filtering lives in
    // src/utilities/monitoring.ts (shouldReportError), and is applied to every
    // error routed through notifyError() and to uncaught errors. (issue #1531)
    initMonitoring();

    // Setup global network error handlers
    setupNetworkErrorHandlers();

    this._usernameInput = createUsernameInput();
    this._passwordInput = createPasswordInput();
  }

  static get styles() {
    return css`
      :host {
        display: block;
      }

      d-app {
        height: 100%;
        width: 100%;
      }
    `;
  }

  connectedCallback() {
    super.connectedCallback();

    this.insertAdjacentElement('beforeend', this._usernameInput);
    this.insertAdjacentElement('beforeend', this._passwordInput);
  }

  render() {
    return html`
      <d-app .bodyScrollTop=${this.bodyScrollTop} .bodyScrollLeft=${this.bodyScrollLeft}>
        <div style="display: flex; align-items: center; justify-content: center; margin-top: 100px; height: 200px;">
          <div style="color: white">${t('app.loading')}</div>
        </div>
        <slot slot="usernameInput" name="usernameInput"></slot>
        <slot slot="passwordInput" name="passwordInput"></slot>
      </d-app>
    `;
  }
}
